import { FC } from 'react';
import { AppIcon, GetReadyIcon } from '../../../../components/icon/png';

const SiteNotAvailable: FC = () => {
  return (
    <div>
      <nav className='header'>
        <img src={AppIcon} alt='app-icon' />
      </nav>
      <div className='body' style={{ margin: 20 }}>
        <img className='not-available-icon' src={GetReadyIcon} alt='get-ready-icon' />
        <h2 className='title' style={{ color: 'black' }}>
          This video call link is no longer active.
        </h2>

        <span style={{ fontWeight: 'bold' }}>We’ve updated our system.</span>

        <p className='subtitle' style={{ color: 'black' }}>
          To join your appointment, please use the unique link sent to you by email or access your
          visit through the Enara Health app.
        </p>

        <span style={{ fontWeight: 'bold' }}>Need help finding your appointment?</span>

        <p className='subtitle' style={{ color: 'black' }}>
          <a
            style={{ color: '#1a667a' }}
            href={`mailto:techsupport@enarahealth.com?subject=${encodeURIComponent(
              'Old video call link'
            )}&body=${encodeURIComponent(
              'I need help joining my telehealth appointment. Can you help me enable email notifications?'
            )}`}>
            Contact support
          </a>{' '}
          or message your provider.
        </p>
      </div>
    </div>
  );
};

export default SiteNotAvailable;
